module.exports = __webpack_public_path__ + "img/il.b3e45cd7.svg";